var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccesos = function SvgAccesos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 48,
    fill: "none",
    viewBox: "0 0 55 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "accesos_svg__Capa_1",
    clipPath: "url(#accesos_svg__clip0_295_1375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector",
    fill: "#19D3C5",
    d: "M3.327 0h19.678c1.835 0 3.327 1.51 3.327 3.37V48H3.327C1.492 48 0 46.49 0 44.63V3.37C0 1.51 1.492 0 3.327 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_2",
    fill: "white",
    d: "M22.826 4.8H3.5v16.5h19.327z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_3",
    fill: "#510C76",
    d: "M33.19 24h-6.858v24h6.858z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_4",
    fill: "#19D3C5",
    d: "M33.19 28.265h-6.858l21.81-24H55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_5",
    fill: "#510C76",
    d: "m32.61 21.179-3.123 3.436h7.188l3.123-3.436z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_6",
    fill: "#510C76",
    d: "m39.448 13.658-3.142 3.456h7.182l3.142-3.456z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_7",
    fill: "#510C76",
    d: "m46.194 6.23-3.083 3.39H50.3l3.076-3.39z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "accesos_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_8",
    fill: "#510C76",
    d: "M32.048 29.335H27.01v2.086h5.037z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_9",
    fill: "white",
    d: "M32.167 31.54h-5.274v-2.325h5.274z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "accesos_svg__Vector_10",
    fill: "#510C76",
    d: "M3.499 4.8h4.237l6.258 16.5H3.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accesos_svg__clip0_295_1375"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h55v48H0z"
  })))));
};
export default SvgAccesos;